export interface FooterNavItem {
  link: string;
  name: string;
  unauthenticatedBase: string;
  authenticatedBase: string;
}

const unauthenticatedBase = '/legal-information';
const authenticatedBase = '/legal';

const baseItems = [
  {
    link: 'imprint',
    name: 'legal.impress',
  },
  {
    link: 'privacy',
    name: 'legal.privacy_policy',
  },
  {
    link: 'agb',
    name: 'legal.agb',
  },
  {
    link: 'accessibilityDeclaration',
    name: 'legal.accessibility_statement',
  },
];

export const footerNavItems: FooterNavItem[] = baseItems.map(item => ({
  ...item,
  authenticatedBase,
  unauthenticatedBase,
}));

// The backend delivers empty legal texts as null, '' or an empty editor paragraph like '<p></p>'.
export const hasLegalText = (text?: string | null): boolean =>
  !!text
    ?.replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, '')
    .trim();
